import { useEffect, useState } from "react"
import styles from "./Header.module.css"
import { NavLink } from "react-router-dom"

function Header() {

    const [clearMode, setClearMode] = useState(localStorage.getItem("theme"))                

    useEffect(() => {
        if(clearMode) {
            document.body.classList.add("clear")
            localStorage.setItem("theme", "clear")
        } else {
            document.body.classList.remove("clear")
            localStorage.setItem("theme", "")
        }
    }, [clearMode])       
    
    const toggleMode = () => {
        setClearMode(!clearMode)
    }

    const [scrolled, setScrolled] = useState(false);

    useEffect(() => {
        function handleScroll() {
        if (window.scrollY > 10) {
            setScrolled(true);
        } else {
            setScrolled(false);
        }
        }

        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll); 
    }, []);


   const [menuOpen, setMenuOpen] = useState(false);

    return(
        <header className={`${styles.header} ${scrolled ? styles.sticky  : ""}`}>

            <div className={styles.divHeader}>
                    <span className={styles.engiforgeImg} ></span>
                <nav>
                    <NavLink to="/"
                        className={({ isActive }) => isActive ? `${styles.navLink} ${styles.active}` : styles.navLink}> Company 
                    </NavLink>

                    <NavLink to="/project" 
                        className={({ isActive }) => isActive ? `${styles.navLink} ${styles.active}` : styles.navLink}> Projects  
                    </NavLink>

                    <NavLink to="/ecosystem"
                        className={({ isActive }) => isActive ? `${styles.navLink} ${styles.active}` : styles.navLink}> Ecosystem 
                    </NavLink>

                    <NavLink to="/contact"
                        className={({ isActive }) => isActive ? `${styles.navLink} ${styles.active}` : styles.navLink}> Contact 
                    </NavLink>

                    <div className={styles.switch} onClick={toggleMode}> 
                        <button className={`${styles.circle} ${clearMode ? styles.act : ""}`}></button>
                    </div>                           
                </nav>
            </div>

            <div className={styles.divBox}>
                <div className={styles.cardNav}>
                    <button className={styles.buttonOpen} onClick={() => setMenuOpen(!menuOpen)}>
                        {menuOpen ? <ion-icon name="close"></ion-icon> : <ion-icon name="menu"></ion-icon> }
                    </button>

                    <div className={menuOpen ? styles.navTrue : styles.navFalse}>
                        <dv className={styles.icon}><ion-icon name="triangle"></ion-icon></dv>

                        <div className={styles.cardLink}>
                            <NavLink to="/"
                                className={({ isActive }) => isActive ? `${styles.navLink} ${styles.active}` : styles.navLink}> Company 
                            </NavLink>

                            <NavLink to="/project" 
                                className={({ isActive }) => isActive ? `${styles.navLink} ${styles.active}` : styles.navLink}> Projects  
                            </NavLink>

                            <NavLink to="/ecosystem"
                                className={({ isActive }) => isActive ? `${styles.navLink} ${styles.active}` : styles.navLink}> Ecosystem 
                            </NavLink>

                            <NavLink to="/contact"
                                className={({ isActive }) => isActive ? `${styles.navLink} ${styles.active}` : styles.navLink}> Contact 
                            </NavLink>
                        </div>
                    </div> 
                </div>

                <span className={styles.engiforgeImg}></span>

                <div className={styles.switch} onClick={toggleMode}> 
                    <button className={`${styles.circle} ${clearMode ? styles.act : ""}`}></button>
                </div>
            </div>

        </header> 
    ) 
}

export default Header